import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getUserTenantConnections = (token, search, page, TenantID, UserID) => {
    return fetch(`${apiUrl}user_tenant_connections?${search ? 'search=' + search : ''}${page ? '&page=' + page : ''}${TenantID ? '&TenantID=' + TenantID : ''}${UserID ? '&UserID=' + UserID : ''}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getUserTenantConnections